// extracted by mini-css-extract-plugin
export default {"form":"Authentication_form__yqzIG","error":"Authentication_error__CJ6iv","actions":"Authentication_actions__AUSfV"};